import styled from "styled-components"

export const ButtonWrapper = styled.div`
display: flex;
  justify-content: flex-end;
  button {
    margin-left: 1rem;
  }
`
